module.exports = __webpack_public_path__ + "ca6daf4901b0d0a8e66133607b3f5202.png";